import { render, staticRenderFns } from "./index.vue?vue&type=template&id=011d8938&scoped=true&"
import script from "./couponCenter.js?vue&type=script&lang=js&"
export * from "./couponCenter.js?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=011d8938&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "011d8938",
  null
  
)

export default component.exports